import SharedButton from "../../components/Shared/SharedButton";
import TextInput from "../../components/Shared/TextInput";
import DropdownComponent from "../../components/Shared/DropdownComponent";
import DatePicker from "../../components/Shared/DatePicker";
import PageHeader from "../../components/Shared/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomers } from "../../store/slices/CustomerSlice";
import { getBranches, GetBusinesses } from "../../store/slices/BusinessSlice";

import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toast from "react-hot-toast";

import { FaArrowLeft } from "react-icons/fa6";
import validSupergitHIS from "../../api/validSupergitHIS";
import {
  converCLaimDateTimeToISOFormat,
  converDateTimeToISOFormat,
} from "../../uitls/ConvertDateTimeInISOFormart";

const VATInvoiceForm = ({ isEdit = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [tpaList, setTpaList] = useState(null);
  const [buisnessList, setBuisnessList] = useState(null);
  const formikRef = useRef();
  const { branches } = useSelector((state) => state.business);
  const ThirdParty = location.state?.ThirdParty;
  const creditNote = location.state?.creditNote;
  const cancel = location.state?.cancel;
  const selectedInvoiceData = location.state?.invoiceData;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const currentDate = moment().format("YYYY-MM-DD");
  const currentMonth = moment().month() + 1;
  const currentYear = moment().year();

  const validationSchema = Yup.object({
    month: Yup.number().required().min(1).max(12),
    year: Yup.number().required().min(2000).max(2100),
    tpa: Yup.mixed().required(""),
    insurance_company_id: Yup.string().required(),
    invoice_no: Yup.string().required(),
    total_gross: Yup.number().required(),
    total_discount: Yup.number().required(),
    reference_no: Yup.string().required(),
    total_deduction: Yup.number().required(),
    total_net: Yup.number().required(),
    branch_id: Yup.mixed().required(),
    date: Yup.date().required(),
    reason: selectedInvoiceData ? Yup.string().required() : Yup.string(),
  });

  const initialValues = React.useMemo(
    () => ({
      month: selectedInvoiceData?.month || currentMonth,
      year: selectedInvoiceData?.year || currentYear,
      insurance_company_id:
        Number(selectedInvoiceData?.insurance_company_id) || "",

      tpa: selectedInvoiceData?.insurance_company?.tpa_id || "",
      branch_id:
        selectedInvoiceData?.branch_id == 0 ||
          selectedInvoiceData?.branch_id == "0"
          ? "All"
          : Number(selectedInvoiceData?.branch_id) || "",
      invoice_no: selectedInvoiceData?.invoice_no || "",
      reference_no: selectedInvoiceData?.reference_no || "",
      date: selectedInvoiceData?.date
        ? new Date(selectedInvoiceData.date)
        : new Date(),
      total_gross: selectedInvoiceData?.total_gross || 0,
      total_discount: selectedInvoiceData?.total_discount || 0,
      total_deduction: selectedInvoiceData?.total_deduction || 0,
      total_net: selectedInvoiceData?.total_net || 0,
      reason: selectedInvoiceData?.reason || "",
    }),
    [selectedInvoiceData, currentMonth, currentYear],
  );

  const onSubmit = async (values) => {
    setLoading(true);
    let { reason, ...rest } = values;
    try {
      let payload = {
        ...rest,
        date: converCLaimDateTimeToISOFormat(values?.date),
        insurance_company_id: String(values?.insurance_company_id),
        branch_id:
          values?.branch_id === "All"
            ? creditNote || cancel
              ? "0"
              : 0
            : creditNote || cancel
              ? String(values?.branch_id)
              : Number(values?.branch_id),
        total_gross: Number(values?.total_gross),
        total_discount: Number(values?.total_discount),
        total_deduction: Number(values?.total_deduction),
        total_net: Number(values?.total_net),
      };

      let response;
      if (selectedInvoiceData?.id) {
        if (cancel) {
          response = await validSupergitHIS.post(
            `/insurance_claim_invoices/revoke`,
            {
              ...payload,
              reason: reason,
              id: selectedInvoiceData?.id,
            },
          )
        } else {
          response = await validSupergitHIS.put(
            creditNote
              ? `/insurance_claim_invoices/${selectedInvoiceData?.id}/revoke`
              : `/insurance_claim_invoices/${selectedInvoiceData?.id}`,
            {
              ...payload,
              reason: reason,
              id: selectedInvoiceData?.id,
            },
          )
        }
      } else {
        if (creditNote) {
          response = await validSupergitHIS.post(
            "insurance_claim_invoices/revoke",
            payload,
          );
        } else {
          response = await validSupergitHIS.post(
            "insurance_claim_invoices",
            payload,
          );
        }
      }
      if (!selectedInvoiceData && !creditNote && !cancel) {
        if (ThirdParty) {
          if (response?.data) {
            navigate("/zatca/thirdparty/p2p-insurance-invoice", {
              state: {
                invoiceData: response?.data?.data,
                path: location?.pathname,
              },
            });
          }
        } else {
          navigate("/manager/p2p-insurance-invoice", {
            state: {
              invoiceData: response?.data?.data,
              path: location?.pathname,
            },
          });
        }
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.error || t(error.message || "Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const formattedBranches =
    branches?.data?.length > 0
      ? branches?.data?.map((branch) => ({
        label: branch.name_en,
        value: branch.id,
      }))
      : [];

  const setRandomValues = () => {
    if (!formikRef.current) return;

    const randomInRange = (min, max, decimals = 2) =>
      (Math.random() * (max - min) + min).toFixed(decimals);

    const values = {
      invoice_no: `INV-${new Date().getFullYear()}-${Math.floor(
        1000 + Math.random() * 9000,
      )}`,
      total_gross: randomInRange(100, 10000),
      total_discount: randomInRange(0, 500),
      total_deduction: randomInRange(0, 300),
    };

    values.total_net = (
      parseFloat(values.total_gross) -
      parseFloat(values.total_discount) -
      parseFloat(values.total_deduction)
    ).toFixed(2);

    formikRef.current.setValues({
      ...formikRef.current.values,
      ...values,
    });
  };

  const getTpaList = async () => {
    try {
      const res = await validSupergitHIS.post("getTpa");
      if (res.data) {
        setTpaList(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getBuisnessList = async (id) => {
    try {
      const res = await validSupergitHIS.post(`companiesByTPA/${id}`);
      if (res.data) {
        setBuisnessList(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (selectedInvoiceData) {
      getBuisnessList(selectedInvoiceData?.insurance_company?.tpa_id);
    }
  }, [selectedInvoiceData]);

  useEffect(() => {
    getTpaList();
    dispatch(getBranches());
  }, []);

  return (
    <div className="flex flex-col w-full gap-2 max-h-[calc(100vh-130px)]">
      <PageHeader
        title={creditNote ? t("Credit Note") : t("Insurance Claim Invoice")}
        showBackBtn
        onBackBtnClick={() => {
          if (ThirdParty) {
            navigate("/zatca/thirdparty", { state: { activeTab: "ins" } });
          } else {
            navigate("/manager/insurance-claim-invoice");
          }
        }}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6  gap-2">
              <TextInput
                name="month"
                type="number"
                min="1"
                max="12"
                label={t("Month")}
                className="w-full"
              />
              <TextInput
                name="year"
                type="number"
                label={t("Year")}
                className="w-full"
              />
              <DropdownComponent
                name="tpa"
                label={t("tpa")}
                placeholder={t("select tpa")}
                options={tpaList?.map((item) => ({
                  label: item?.name_en,
                  value: item?.id,
                }))}
                onChange={(e) => {
                  formik.setFieldValue("tpa", e.value);
                  getBuisnessList(e.value);
                }}
              />
              <DropdownComponent
                name="insurance_company_id"
                label={t("Insurance Company")}
                placeholder={t("select insurance company")}
                options={buisnessList?.map((item) => ({
                  label: `${item?.name_en} (${item?.short_name})`,
                  value: item?.id,
                }))}
              />
              <DropdownComponent
                name="branch_id"
                label={t("Branch")}
                placeholder={t("select branch")}
                options={[
                  {
                    label: "Select All",
                    value: "All",
                  },
                  ...formattedBranches,
                ]}
              />
              {selectedInvoiceData && (
                <>
                  <TextInput
                    name="reason"
                    label={t("Reason")}
                    placeholder={t("enter reason")}
                    className="w-full"
                  />
                </>
              )}
              {!selectedInvoiceData && !creditNote && (
                <div className="flex flex-col gap-1 w-full mb-1">
                  <label className="input-label invisible">{t("Find")}</label>
                  <SharedButton
                    label={t("FIND")}
                    disabled={
                      !formik.values.insurance_company_id ||
                      !formik.values.branch_id
                    }
                    onClick={setRandomValues}
                    className="h-fit w-full"
                  />
                </div>
              )}
            </div>

            <div className="border rounded p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
                <TextInput
                  name="invoice_no"
                  label={t("INVOICE NO")}
                  placeholder={t("enter invoice no")}
                  className="w-full"
                />
                <TextInput
                  name="reference_no"
                  label={t("Refrence NO")}
                  placeholder={t("enter refrence no")}
                  className="w-full"
                />

                <DatePicker
                  name="date"
                  label={t("DATE")}
                  placeholder={t("select date")}
                  className="w-full"
                />

                <TextInput
                  name="total_gross"
                  type="number"
                  step="0.01"
                  label={t("Total Gross")}
                  placeholder={t("enter total gross")}
                  className="w-full  mb-2"
                />
                <TextInput
                  name="total_discount"
                  type="number"
                  step="0.01"
                  label={t("Total Discount")}
                  placeholder={t("enter total discount")}
                  className="w-full  mb-2"
                />
                <TextInput
                  name="total_deduction"
                  type="number"
                  step="0.01"
                  label={t("Total Deduction")}
                  placeholder={t("enter total deduction")}
                  className="w-full  mb-2"
                />
                <TextInput
                  name="total_net"
                  type="number"
                  step="0.01"
                  label={t("Total Net")}
                  placeholder={t("enter total net")}
                  className="w-full "
                />
              </div>
            </div>

            <div className="flex justify-end">
              <SharedButton
                icon="pi pi-print"
                type="submit"
                loading={loading}
                label={`${selectedInvoiceData ? t("UPDATE") : t("CREATE")} ${creditNote ? t("Credit Note") : t("INVOICE")
                  }`}
                className="submit-btn"
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default VATInvoiceForm;
